import { Component, inject, Input } from '@angular/core';
import { AuthService, LinksService } from '@isophi/core-legacy';

type InfoBannerType = 'demo' | 'trial' | 'trial-expired' | 'license-expiring' | 'license-expired';

@Component({
    selector: 'app-info-banner',
    templateUrl: './info-banner.component.html',
    styleUrls: ['./info-banner.component.scss'],
    standalone: false
})
export class InfoBannerComponent {
  protected readonly authService = inject(AuthService);
  protected readonly linkService = inject(LinksService);

  @Input() type: InfoBannerType = 'trial';
  @Input() daysLeft?: number;

  /**
   * Redirect user to the management application pricing page.
   */
  handleRedirectToPriceList(): void {
    const link = this.linkService.getManagementAppUrl({ redirect: '/settings/price-list' });
    window.open(link.url, link.target);
  }

  get canRenew(): boolean {
    return !!(this.authService.loggedUser?.teacher?.isDirector() || this.authService.loggedUser?.teacher?.isManager());
  }
}
